import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import ChemicalSelectionFields from "../ChemicalSelectionFields";

import "./index.scss";

const ChemicalsUsedForCleaning = ({
  chemicalsUsed,
  onChemicalsChange,
  setMandatoryComponentsStatus,
}) => {
  const { t } = useTranslation();
  const { plantChemicalLibrary } = useSelector((state) => state);

  const handleChemicalChange = (key, option) => {
    onChemicalsChange((prev) => {
      const updatedChemicals = { ...prev };
      const chemId = plantChemicalLibrary.find(
        (chem) => chem.display_name === option.value,
      )?.chem_id;

      updatedChemicals[key] = {
        chem_id: chemId,
        chemical_name: option.label,
        price: option.price,
      };
      return updatedChemicals;
    });

    if (setMandatoryComponentsStatus) {
      setMandatoryComponentsStatus((prev) => ({
        ...prev,
        chemicalsUsedForCleaning: {
          ...prev.chemicalsUsedForCleaning,
          changed: true,
          fulfilled: true,
          error: false,
        },
      }));
    }
  };

  return (
    <div className="ro-card-wrapper position-relative">
      <div className="ro-card-header">
        <div className="teal-heading">
          {t("chemicalsUsedForCleaning.title")}
        </div>
      </div>

      <ChemicalSelectionFields
        selectedChemicals={chemicalsUsed}
        onChemicalChange={handleChemicalChange}
        containerClassName="chemicals-used-cleaning-grid"
        showPriceField={false}
      />
    </div>
  );
};

export default ChemicalsUsedForCleaning;
